angular.module('iqxCore')
.controller('ActionDialogLegacyContactDetailsModalCtrl', function ($scope, FormSvc) {
	$scope.noContactDetails=false
	$scope.selects={}
	$scope.selects.contacts=[]

	FormSvc.setOptions($scope,{
		fetchAPI:'callresult/NetOwnerActionDialog?pObjectID='+$scope.ActionDialog.obj.linkID,
		fetchTarget:'actions',
		multiRow:true
	})

	if ($scope.ActionDialog.obj.type=="Company") {
		$scope.companyID=$scope.ActionDialog.obj.linkID
		$scope.fetch({
			fetchAPI:'callresult/NetOwnerContactList?pCompanyID='+$scope.ActionDialog.obj.linkID,
	  		fetchTarget:'companyContacts',
	  		multiRow:true
	  	})
	  	.then(function(){
	  		$scope.companyContacts.push({"Value":$scope.companyID, "Descrip":"Company: " + $scope.ActionDialog.obj.title})
	  	})
	}

	$scope.reFetchContactDetails=function(contact){
		$scope.fetch({
			fetchAPI:'callresult/NetOwnerActionDialog?pObjectID='+contact.Value,
	  		fetchTarget:'actions',
	  		multiRow:true
	  	})
		.then(function(){
			$scope.showContactDetails()
		})
	}

	$scope.showContactDetails=function(){
		if(!$scope.actions[0].number){
			$scope.noContactDetails=true
		} else {
			$scope.name=$scope.ActionDialog.obj.title
		}
	}

	$scope.contactAction=function(action, details){
		window.location.href=action+":"+details
		$scope.$close()
		$scope.makeContactEvent()
	}

	$scope.goBack=function(){
		$scope.ActionDialogBody = undefined
	}

	$scope.fetch()
	.then(function(){
		$scope.showContactDetails()
	})
})